import { Link, Outlet, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/workadayLogoMain2.svg";
import { ReactComponent as ActiveJobs } from "../assets/activeJobs.svg";
import { ReactComponent as JobHistory } from "../assets/order.svg";
import { ReactComponent as Bid } from "../assets/bid.svg";
import { ReactComponent as ProfileIcon } from "../assets/profile.svg";

import InformationBanner from "./InformationBanner";
import SideDrawer from "../Common/Drawer/SlideDrawer";
import { useContext, useState } from "react";
import Backdrop from "../Common/Drawer/Overlay";
import { UserContext } from "../Providers/UserProvider";

const NavigationBar = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const { hasRole } = useContext(UserContext);
  const navigation = useNavigate();

  return (
    <div>
      <div className=" w-full shadow-lg bg-primary mb-10 lg:px-[45px]">
        <div className="flex">
          <Link to={"/"}>
            <div className="flex justify-start m-auto items-start font-extrabold text-accent  overflow-hidden ">
              {/** Company Logo */}
              <Logo className=" w-32 h-20 fill-base-100 lg:ml-0 ml-6 " />
            </div>
          </Link>
          <div className="flex w-full justify-center items-center">
            {/** Center Navigation Bar Items */}
          </div>
          <div className=" hidden lg:flex justify-end items-center pr-4">
            {/** Quick Icon Navigation */}

            {hasRole("Jobber") ? (
              <div
                className="w-14 cursor-pointer has-tooltip"
                onClick={() => navigation("contractor/active/jobs")}
              >
                <ActiveJobs className=" h-8 stroke-base-100 " />
                <span className="tooltip rounded shadow-lg py-2 px-4 bg-black text-base-100  -translate-x-6 mt-2 text-xs">
                  My Work
                </span>
              </div>
            ) : null}
            {hasRole("Jobber") ? (
              <div
                className="w-14 cursor-pointer has-tooltip"
                onClick={() => navigation("contractor/job/auctions")}
              >
                <Bid className=" h-8 stroke-white hover:fill-secondary" />
                <span className="tooltip rounded shadow-lg py-2 px-4 bg-black text-white  -translate-x-6 mt-2 text-xs">
                  Job Auction
                </span>
              </div>
            ) : null}

            {hasRole("User") ? (
              <div
                className=" w-14 cursor-pointer has-tooltip relative "
                onClick={() => navigation("user/account/job/history")}
              >
                <JobHistory className=" h-8 stroke-white hover:fill-secondary" />
                <span className="tooltip rounded shadow-lg py-2 px-4 w-[100px]  bg-black text-white  -translate-x-8 mt-2 text-xs ">
                  Job History
                </span>
              </div>
            ) : null}

            <div
              className="text-white hover:cursor-pointer h-10 w-10 rounded-full hover:bg-slate-400 flex justify-center items-center bg-primary"
              onClick={() => setShowDrawer(true)}
            >
              <ProfileIcon className=" h-8 stroke-white" />
            </div>
          </div>

          <div className=" flex lg:hidden justify-end items-center pr-4">
            <div
              className="text-white hover:cursor-pointer h-10 w-10 rounded-full hover:bg-slate-400 flex justify-center items-center bg-primary"
              onClick={() => setShowDrawer(true)}
            >
              <ProfileIcon className=" h-8 stroke-white " />
            </div>
          </div>
        </div>
      </div>
      <SideDrawer
        show={showDrawer}
        closeFunc={() => setShowDrawer(!showDrawer)}
      />
      {showDrawer ? (
        <Backdrop close={() => setShowDrawer(!showDrawer)} />
      ) : null}
      <InformationBanner />

      <Outlet />
    </div>
  );
};

export default NavigationBar;
